import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 0.5,
};

export const text: SxStyle = {
  textWrap: 'nowrap',
};
